import {
  Component,
} from "react";
import {
  Link,
} from "react-router-dom";
import {
  Button,
} from "react-bootstrap";
import {
  Awesome,
} from "CommonComponents/bricks";

export function getCookie(name) {
  const r = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  if (r) {
    return r[2];
  }
  return false;
}

export default class CookieBanner extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    this.checkCookie();
  }

  save = () => {
    const { onSave } = this.props;
    this.setCookie("eportal", true);
    this.checkCookie();
    if (onSave) {
      onSave();
    }
  };

  setCookie = (name, value) => {
    // Ablauf nach einem Jahr.
    document.cookie = name + "=" + value + ";max-age=31536000; path=/";
  };


  checkCookie() {
    const cookieApp = getCookie("eportal");
    if (!cookieApp) {
      this.setState({ CookiesBoxShow: true });
    } else {
      this.setState({ CookiesBoxShow: false });
    }
  }

  render() {
    if (this.state.CookiesBoxShow) {
      return <span><div className='cookies-box no-print' style={{ textAlign: "center", backgroundColor: "white" }}>
        <div className='secondary-container'>
          <div className='site-root padding-bottom-xs padding-top-xs font-size-sm note-box'>Hinweis zur Verwendung von
            Cookies
          </div>
        </div>
        <div className='tertiary-container'>
          <div className='site-root padding-bottom-xs padding-top-xs font-size-xs'>
            <span>Unsere Webseite verwendet Cookies, die für die Verbesserung der Funktionalitäten unserer
              Webseite und deren Anpassung an das Nutzerverhalten notwendig sind. Mit dem Klick auf den
              untenstehenden Button oder mit Ihrer weiteren Nutzung der Webseite erklären Sie sich damit einverstanden.
            </span>
            <br />
            <Link to='/datenschutz'>Weitere
              Informationen hierzu finden Sie in unserer Datenschutzerklärung.</Link>
            <br />
            <Button onClick={this.save} variant='primary'>
              <Awesome name='check-circle' />{"\u00a0"}
              Ich stimme zu.
            </Button>
          </div>
        </div>
      </div>
      </span>;
    }
    return null;
  }
}
